/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Parts_Not_Found_SuccessInputs */

const en_ticket_action_parts_not_found_success = /** @type {(inputs: Ticket_Action_Parts_Not_Found_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reported as not found at PUDO.`)
};

const ja_ticket_action_parts_not_found_success = /** @type {(inputs: Ticket_Action_Parts_Not_Found_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PUDOで見つからないと報告しました。`)
};

const fr_ticket_action_parts_not_found_success = /** @type {(inputs: Ticket_Action_Parts_Not_Found_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signalées comme introuvables au PUDO.`)
};

const de_ticket_action_parts_not_found_success = /** @type {(inputs: Ticket_Action_Parts_Not_Found_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als nicht am PUDO gefunden gemeldet.`)
};

/**
* | output |
* | --- |
* | "Reported as not found at PUDO." |
*
* @param {Ticket_Action_Parts_Not_Found_SuccessInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_parts_not_found_success = /** @type {((inputs?: Ticket_Action_Parts_Not_Found_SuccessInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Parts_Not_Found_SuccessInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_parts_not_found_success(inputs)
	if (locale === "ja") return ja_ticket_action_parts_not_found_success(inputs)
	if (locale === "fr") return fr_ticket_action_parts_not_found_success(inputs)
	return de_ticket_action_parts_not_found_success(inputs)
});